// 添加区域配置
export const areaOption = {
        maxHeight:400,
        cellBtn:false,
        addBtn:false,
        header:false,
        menu:false,
        index:true,
        indexLabel:"序号",
        height: 'auto',
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        selection: true,
        viewBtn: true,
        column:[
                {
                        label:'区域编号',
                        prop:'code'

                },
                {
                        label:'区域名称',
                        prop:'name'

                },
                {
                        label:'区域全程',
                        prop:'fullName'

                },
                {
                        label:"所属部门",
                        prop:'$deptId'

                }
        ]
}
// 添加设备配置
export const deviceOption = {
        maxHeight:400,
        cellBtn:false,
        addBtn:false,
        header:false,
        menu:false,
        index:true,
        indexLabel:"序号",
        height: 'auto',
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        selection: true,
        viewBtn: true,
        column:[
                {
                        label: '设备名称',
                        prop: 'name',
                        slot:true
                },
                {
                        label: '设备编号',
                        prop: 'code',
                },
                {
                        label: '设备类型',
                        prop: 'typeName',
                },

                {
                        label: '所属部门',
                        prop: 'deptName',
                },
                {
                        label: '存放位置',
                        prop: 'areaName',
                },

                {
                        label: '标准',
                        prop: 'standardName',
                        slot:true
                },
        ]
}

export function omitNumber(e) {
        let value = e;
        if(value.indexOf(".")<0){
        value = value.slice(0,9)
        }
        if(value.indexOf(".")>=9){
        value = value.slice(0,9) + value.slice(value.indexOf("."))
        }
        value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
        value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
        value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
        if (value.indexOf(".") < 0 && value != "") {
                //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                value = parseFloat(value);
        }
        if(value=='.'){
                value = '0.'
        }
        return value;
}